import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import LicenseAddOnUpsertMenuItem from "@/v2-backoffice-client/license/addOns/catalog/LicenseAddOnUpsertMenuItem"
import LicenseAddOnRetireMenuItem from "@/v2-backoffice-client/license/addOns/catalog/LicenseAddOnRetireMenuItem"
import type { AddOnCatalogFragment } from "@/v2-backoffice-client/license/addOns/catalog/__types__/license.addOn.catalog.fragment"

export type LicenseAddOnCatalogRowToolbarProps = {
  addOn: AddOnCatalogFragment
}

// Row actions on the add-on catalog board: identity/scope edit and retire.
// What the package unlocks and who holds it are managed on the add-on's
// panel (the row's name link); granting to a license stays on the customer
// panel, where the license context is.
function LicenseAddOnCatalogRowToolbar(
  props: LicenseAddOnCatalogRowToolbarProps,
) {
  const { addOn } = props

  return (
    <ActionMenu>
      <ActionMenu.Trigger />
      <ActionMenu.Content>
        <LicenseAddOnUpsertMenuItem addOn={addOn} />

        <ActionMenu.Separator />
        <LicenseAddOnRetireMenuItem addOn={addOn} />
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default LicenseAddOnCatalogRowToolbar
